export default __webpack_public_path__ + "media/images/landing-35-550x420-df9ce39bf440b928da614c2ade342afe.jpg";